import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ImageComponent } from 'components/atoms/image/image.component';
import type { ILocaleWithLink } from 'src/services/url-localise/entities';
import type { THeaderLayoutTheme } from 'src/shared/types/color-schemes-and-themes';

import { imageConfig } from './entities/image-config';

@Component({
    selector: 'website-language-selector-section',
    templateUrl: './language-selector-section.component.html',
    styleUrls: ['./language-selector-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass, ImageComponent],
})
export class LanguageSelectorSectionComponent {
    @Input() public readonly theme: THeaderLayoutTheme;
    @Input() public readonly languages: ILocaleWithLink[][];
    @Input() public readonly isAnyNavItemOpen: boolean;
    @Input() public readonly isCurrentNavItemOpened: boolean;
    public imageConfig = imageConfig;

    public get LANGUAGE_SELECTOR_PATH(): string {
        return `/tp/static/assets/img/header-v2/language-selector-${this.theme}.png`;
    }
}
